
export const SERVER_URL = "https://gw.thussat.cn"; // 正式环境
export const DEVELOPMENT_SERVER_URL = "https://ysslapi.thussat.cn"; //开发环境
